import InviteToDemo from './InviteToDemo';
import { registerFeature } from "../../middlewares/apiMiddleware";
import internalMiddleware from "../../middlewares/featureApis/internalMiddleware";
registerFeature("INTERNAL", internalMiddleware);

export default InviteToDemo